module.exports = __webpack_public_path__ + "static/img/new-home-item3.42901352.jpg";